import script from "./ClientForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientForm.vue?vue&type=script&setup=true&lang=js"

import "./ClientForm.vue?vue&type=style&index=0&id=1794e8e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1794e8e5"]])

export default __exports__